import styled, { css } from "styled-components";

const Slider = styled.input<{ points?: number }>`
  visibility: hidden;
  opacity: 0;
  position: absolute;
  width: 50%;
  left: 25%;
  right: 25%;
  top: 25%;
  transition: visibility 0.5s;
  transition: opacity 0.5s;
  margin: 0;

  -webkit-appearance: none; /* Override default CSS styles */
  appearance: none;
  height: 50%;
  background: var(--color-text-light);
  outline: none; /* Remove outline */

  border-radius: 1em;

  ::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    width: 1.3em; /* Set a specific slider handle width */
    height: 1.3em;
    cursor: pointer; /* Cursor on hover */
    border: 0px;
    border-radius: 1em;
    ${({ points }) => {
      if (points === 2) {
        return css`
          background: var(--color-field-point-2);
        `;
      }
      if (points === 1) {
        return css`
          background: var(--color-field-point-1);
        `;
      }
      return css`
        background: var(--color-field-point-0);
      `;
    }}
  }

  ::-moz-range-thumb {
    border: 0px;
    width: 1.3em; /* Set a specific slider handle width */
    height: 100%;
    cursor: pointer; /* Cursor on hover */
    border-radius: 1em;
    ${({ points }) => {
      if (points === 2) {
        return css`
          background: var(--color-field-point-2);
        `;
      }
      if (points === 1) {
        return css`
          background: var(--color-field-point-1);
        `;
      }
      return css`
        background: var(--color-field-point-0);
      `;
    }}
  }
`;

export default Slider;
